import { render, staticRenderFns } from "./PublicationsCuratorsExpansionTable.vue?vue&type=template&id=8524fea2&"
import script from "./PublicationsCuratorsExpansionTable.vue?vue&type=script&lang=js&"
export * from "./PublicationsCuratorsExpansionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports